var render = function render(){var _vm=this,_c=_vm._self._c;return _c('side-bar-button-primary',{on:{"click":function($event){return _vm.goToMetrics()}},scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('message["navigator.bottom-bar.metrics"]').toLowerCase())+" ")]},proxy:true},{key:"icon",fn:function(){return [_c('icon-metrics',{attrs:{"size":"sm2"}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }